import { render, staticRenderFns } from "./NoBalanceAllocation.vue?vue&type=template&id=1caca048&scoped=true&"
import script from "./NoBalanceAllocation.vue?vue&type=script&lang=js&"
export * from "./NoBalanceAllocation.vue?vue&type=script&lang=js&"
import style0 from "./NoBalanceAllocation.vue?vue&type=style&index=0&id=1caca048&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1caca048",
  null
  
)

export default component.exports